import React from 'react';
import myImage from './kachel_eckdusche.jpg';

const kachelEckdusche = () => {
    return (
        <img src={myImage} width="100" height="50" />
    )
}

export default kachelEckdusche;



